import { useEffect, useState } from 'react';
import { useNavegate } from 'App/hooks';
import { useModal } from 'commons/hooks';
import { useCreateDomainMutation } from 'domains/Configurations/Domains/domainsApi';
import { CREATE_DOMAIN_CACHE_KEY } from 'domains/Configurations/Domains/utils';

interface CreatedDomainInfo {
  id: string;
  name: string;
  isSubdomain: boolean;
  supportsOurDns: boolean;
}

export function useDomainsLandingPage() {
  const { getQueryParam, removeSearchParams } = useNavegate();

  const [showAddDomainModal, openAddDomainModal, closeAddDomainModalBase] =
    useModal(false);
  const [
    showAddExistingDomainModal,
    openAddExistingDomainModal,
    closeAddExistingDomainModal,
  ] = useModal(false);
  const [showAttachDomainModal, openAttachDomainModal, closeAttachDomainModal] =
    useModal(false);
  const [
    showEditOurDomainModal,
    openEditOurDomainModal,
    closeEditOurDomainModal,
  ] = useModal(false);

  const [createdDomainInfo, setCreatedDomainInfo] =
    useState<CreatedDomainInfo | null>(null);
  const [initialSearchQuery, setInitialSearchQuery] = useState<
    string | undefined
  >(undefined);

  const closeAddDomainModal = () => {
    setInitialSearchQuery(undefined);
    closeAddDomainModalBase();
  };

  const [
    ,
    {
      status: createDomainStatus,
      data: createDomainData,
      reset: resetCreateDomain,
    },
  ] = useCreateDomainMutation({
    fixedCacheKey: CREATE_DOMAIN_CACHE_KEY,
  });

  useEffect(() => {
    const searchParam = getQueryParam('search');
    const openSearchParam = getQueryParam('openSearch');

    if ((searchParam || openSearchParam) && !showAddDomainModal) {
      setInitialSearchQuery(searchParam || '');
      openAddDomainModal();
      removeSearchParams(['search', 'openSearch']);
    }
  }, [
    getQueryParam,
    removeSearchParams,
    openAddDomainModal,
    showAddDomainModal,
  ]);

  useEffect(() => {
    if (createDomainStatus === 'fulfilled' && createDomainData?.[0]) {
      const newDomain = createDomainData[0];
      setCreatedDomainInfo({
        id: newDomain.id,
        name: newDomain.name,
        isSubdomain: newDomain.isSubdomain,
        supportsOurDns: newDomain.supportsOurDns,
      });
      closeAddExistingDomainModal();
      openAttachDomainModal();
    }
  }, [
    createDomainStatus,
    createDomainData,
    closeAddExistingDomainModal,
    openAttachDomainModal,
  ]);

  return {
    showAddDomainModal,
    closeAddDomainModal,
    showAddExistingDomainModal,
    setCreatedDomainInfo,
    openAddExistingDomainModal,
    closeAddExistingDomainModal,
    showAttachDomainModal,
    createdDomainInfo,
    closeAttachDomainModal,
    resetCreateDomain,
    openAddDomainModal,
    showEditOurDomainModal,
    openEditOurDomainModal,
    closeEditOurDomainModal,
    initialSearchQuery,
    setInitialSearchQuery,
  };
}
